import axios from "axios";
import { API_URL } from "../utils/Constant";
import { getUser } from "../utils/helpers";

// get a list of tests and result for the PCR tabs
// options: { category?: "update" | "retest" | "pending", date?: "MM/DD/YYYY" }
// https://d829e04f35aa.ngrok.io/api/pathogentests/?genista_id=051821_801
export const getTestsDataForPcr = async (genistaId, options = {}) => {
  try {
    const params = {
      genista_id: genistaId || "",
      ...options,
    };
    const response = await axios.get(`${API_URL}/pathogentests/`, { params });
    const data = await response.data;

    const res = { data: [] };
    const result = data.result;
    if (result && result.length > 0) {
      res.data = result;
    }

    // testing only
    // res.data = [
    //   {
    //     "Analysis": "aaa",
    //     "SampleType": "111"
    //   },
    //   {
    //     "Analysis": "bbb",
    //     "SampleType": "222"
    //   }
    // ]

    return { success: true, ...res };
  } catch (e) {
    return { success: false, message: "Something went wrong" };
  }
};

// http://127.0.0.1:5000/api/pcrpendingtable/
export const getTestsDataForPcrPending = async () => {
  try {
    const response = await axios.get(`${API_URL}/pcrpendingtable`);
    const data = await response.data;

    const res = { data: [] };
    if (data && data.length > 0) {
      const result = data[0].result;
      if (result && result.length > 0) {
        const list = result[0].List;
        if (list && list.length > 0) {
          for (let i = 0; i < list.length; i++) {
            list[i].option = "Select";
          }
          res.data = list;
        }
      }
    }

    // testing only
    // res.data = [
    //     {
    //     "OrderId": "052921_106",
    //     "GenistaId": "GB052921_431",
    //     "Analysis": "Staph spp",
    //     "option": "Select"
    //     },
    //     {
    //     "OrderId": "052921_106",
    //     "GenistaId": "GB052921_432",
    //     "Analysis": "Staph spp",
    //     "option": "Select"
    //     },
    //     {
    //     "OrderId": "052921_107",
    //     "GenistaId": "GB052921_434",
    //     "Analysis": "Staph spp",
    //     "option": "Select"
    //     },
    //     {
    //     "OrderId": "052921_107",
    //     "GenistaId": "GB052921_436",
    //     "Analysis": "Staph spp",
    //     "option": "Select"
    //     },
    //     {
    //     "OrderId": "052921_107",
    //     "GenistaId": "GB052921_433",
    //     "Analysis": "Staph spp",
    //     "option": "Select"
    //     },
    //     {
    //     "OrderId": "052921_107",
    //     "GenistaId": "GB052921_435",
    //     "Analysis": "Staph spp",
    //     "option": "Select"
    //     }
    // ]

    return { success: true, ...res };
  } catch (e) {
    return { success: false, message: "Something went wrong" };
  }
};

// set Positive / Reset / Hold
export const saveTestDataForPcr = async (payload) => {
  try {
    const user = getUser();
    // console.log("===== saveTestDataForPcr payload", payload);
    const response = await axios.patch(`${API_URL}/updatepathogendata/`, {
      genista_id: payload.genista_id || "",
      analysis: payload.analysis || "",
      result: payload.result || "",
      workorder_id: payload.workorder_id,
      user_email: user.email,
    });
    const data = await response.data;
    return { success: true, ...data };
  } catch (e) {
    const message = e?.response?.data?.message || "Something went wrong.";
    return { success: false, message };
  }
};

/**
 * Set all PCR sample results to default value and mark the tests as Ready
 * 1. Mark Rush Samples
 * 2. Mark Regular Samples
 * 3. Mark Plate Map Samples
 * @param {*} params
 *  For Rush/Regular: { date: MM/DD/YYYY, category: "Rush" | "Regular", user_email:string  }
 *  For Platemap: { platemap_id: string, category: "Platemap", user_id: int }
 */
export const markPcrSamplesNegative = async (params) => {
  try {
    const res = await axios.get(`${API_URL}/pcrstatus/`, { params });
    return { success: true, ...res.data };
  } catch (e) {
    return { success: false, message: "Something went wrong" };
  }
};

/**
 * Fetch the plate map ids for the given date
 * @param {*} params { date: MM/DD/YYYY, category: "get_info"}
 * @returns {Object} { success: true, result: string[] }
 */
export const fetchPlateMapIds = async (params, signal = null) => {
  try {
    const response = await axios.get(`${API_URL}/pcrstatus/`,
      {
        params,
        signal,
      });
    return { success: true, ...response.data };
  } catch (e) {
    const message = "Failed to fetch plate map ids";
    return {
      success: false,
      message,
      status_code: e?.response?.status ?? 400,
      error_message: e?.message ?? "Fail",
      canceled: e.code === "ERR_CANCELED",
    };
  }
};

export const saveRushWo = async (payload) => {
  try {
    const res = await axios.get(`${API_URL}/shelflifewo/`, {
      params: {
        wo: { wo_list: payload },
      },
    });
    const data = await res.data;
    return { success: true, ...data };
  } catch (e) {
    return { success: false, message: "Something went wrong" };
  }
};

export const uploadXMLFile = async (location) => {
  // const formData = {
  //   'aws_path': data,
  // };

  // console.log(formData);

  try {
    const response = await axios.post(`${API_URL}/xmlupload/`, {
      aws_path: location,
      headers: {
        "content-type":
          "multipart/form-data; boundary=----WebKitFormBoundaryA1pn2FoXQZe10gTo",
      },
    });
    const data = await response.data;
    return { success: true, ...data };
  } catch (e) {
    const message = "Something went wrong";
    return { success: false, message };
  }
};

export const pcrResults = async (data) => {
  try {
    const response = await axios.post(`${API_URL}/pcrresults/`, {
      Experiment: data.Experiment,
      Created: data.Created,
      Instrument: data.Instrument,
      Analyses: data.Analyses,
    });

    // let data = await response.data;
    return { success: true, ...response };
  } catch (e) {
    const message = "Something went wrong";
    return { success: false, message };
  }
};

// manual pcr
export const manualPcr = async (target_date, signal = null) => {
  try {
    const response = await axios.get(`${API_URL}/manualpcr/`, {
      params: {
        date: target_date || "",
      },
      signal,
    });

    const data = await response.data;
    const res = { list: [] };
    const list = data.List;
    if (list && list.length > 0) {
      res.list = list;
    }

    return { success: true, ...res };
  } catch (e) {
    const message = "Something went wrong.";
    return { success: false, message, canceled: e.code === "ERR_CANCELED" };
  }
};

export const pendingManualPcr = async () => {
  try {
    const response = await axios.get(`${API_URL}/pendingmanualpcr/`);
    const data = await response.data;
    return { success: true, ...data };
  } catch (e) {
    const message = "Something went wrong.";
    return { success: false, message };
  }
};

export const updateManualPcr = async (payload) => {
  try {
    const response = await axios.post(`${API_URL}/updatemanualpcr/`, payload);
    const data = await response.data;
    if (response.status === 207) {
      const fallback = "Few result update is blocked. Please contact QC team.";
      return {
        success: false,
        status207: true,
        message: (data?.message?.trim() || fallback),
        result: data?.result ?? [],
      };
    }
    return { success: true, ...data };
  } catch (e) {
    const message = e?.response?.data?.message || "Something went wrong.";
    return { success: false, message };
  }
};
